/**
 *
 * UnloadingZoneOperatorView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';

function UnloadingZoneOperatorView({ dataTable, formDialog, viewName, viewStyles }) {
  return (
    <div style={viewStyles.root}>
      <Paper style={viewStyles.dataTable}>
        {
          React.cloneElement(dataTable, { viewName })
        }
      </Paper>
      { formDialog }
    </div>
  );
}

UnloadingZoneOperatorView.propTypes = {
  dataTable: PropTypes.node.isRequired,
  formDialog: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  viewStyles: PropTypes.object,
};

UnloadingZoneOperatorView.defaultProps = {
  viewStyles: {},
};

export default UnloadingZoneOperatorView;
